import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { CompanyService } from 'app/services/company.service';
import { BaseFormComponent } from "../../base-form.component";
import { ToasterService } from './../../../../../services/user-interaction/services/toaster.service';
import { GlobalConfigFormComponent } from '../global-config-form/global-config-form.component';
import { cloneDeep } from 'lodash';
import { GlobalConfig } from 'app/models/global-config.model';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'company-form',
    templateUrl: './company-form.component.html',
    styleUrls: ['./company-form.component.scss']
})
export class CompanyFormComponent extends BaseFormComponent implements OnInit {

    private globalConfigId?:number;
    private _company: Company = {}
    public get model() {
        return this._company
    }
    public set model(v: Company) {
        this._company = v;
    }
    constructor(
        private _companyService: CompanyService,
        private _toasterService: ToasterService,
        private _translateService: TranslateService,
        private _dialog:MatDialog
    ) {
        super();
    }


    public async ngOnInit() {

    }

    public async save() {
        if (this.form.invalid) {
            this._toasterService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }
        this.model.status = true;
        this.model.globalConfigId = this.globalConfigId;
        try {
            this.operation == 'create'
                ? await this._companyService.add(this.model)
                : await this._companyService.updated(this.model)

            this.operation == "create"
                ? this.added.emit(true)
                : this.updated.emit(true);
        } catch (error) {
            console.warn(error);
            this.operation == "create"
                ? this.added.emit(false)
                : this.updated.emit(false);
        }
    }

    public globalConfigClick(company:Company) {
        const dialog = this._dialog.open(GlobalConfigFormComponent, {
            width: '800px'
        });
        dialog.componentInstance.operation = company.globalConfig ? "update" : "create";
        dialog.componentInstance.model = cloneDeep(company.globalConfig ? company.globalConfig : new GlobalConfig);
        dialog.componentInstance.added.subscribe((model: GlobalConfig) => {
            this.globalConfigId = model.id;
            dialog.close();
        })

        dialog.componentInstance.updated.subscribe((model: GlobalConfig) => {
            this.globalConfigId = model.id;
            dialog.close();
        })
    }
}
